import MuiRadio, { RadioProps } from '@mui/material/Radio';

import React from 'react';

interface Props {
  coloredOutline?: boolean; // Apply same color to the outline
}

const UIRadio: React.FC<Props & RadioProps> = ({ color = 'primary', coloredOutline = true, ...rest }) => (
  <MuiRadio sx={coloredOutline ? { color: `${color}.main`, '&.Mui-checked': { color: `${color}.main` } } : {}} {...rest} />
);

export default UIRadio;
